export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/process-label-pointer.3eaf10f3-d4b688.svg";